<template>
  <div style="width: 100%;background-color: #3b4054; padding: 0px 8px;">
    <ul
      style="list-style: none; margin: 0; padding: 0; display: flex; align-items: center; height: 100%;"
    >
      <navigation-item
        label="Campaign Dashboard"
        to="/admin-tools/campaign"
      ></navigation-item>
      <navigation-item
        label="Email Configuration"
        to="/admin-tools/email-configuration"
      ></navigation-item>
      <navigation-item
        label="Campaign Ad Listing"
        to="/admin-tools/campaign-ad-listing"
      ></navigation-item>
      <navigation-item
        label="XML Import Logs"
        to="/admin-tools/xml-import-logs"
      ></navigation-item>
    </ul>
  </div>
</template>
<script>
import NavigationItem from './NavigationItem.vue';
export default {
  components: {
    NavigationItem,
  },
};
</script>
